import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=b4b6cab0&"
import script from "./PeriodicTable.vue?vue&type=script&lang=js&"
export * from "./PeriodicTable.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PeriodicTable.vue"
export default component.exports